<template>
  <router-link v-if="to" :to="to"> 승인 </router-link>
  <span v-else :class="request.status" class="font-weight-black">
    {{ code(request.status) }}
  </span>
</template>

<script>
export default {
  props: ['request'],
  data() {
    return {
      to: null,
      statuses: [
        {
          'code': 'init',
          'name': '신청'
        },
        {
          'code': 'calculating_limits',
          'name': '한도산출중'
        },
        {
          'code': 'submitting_documents',
          'name': '서류제출중'
        },
        {
          'code': 'in_review',
          'name': '심사중'
        },
        {
          'code': 'approve',
          'name': '승인'
        },
        {
          'code': 'reject',
          'name': '반려'
        },
        {
          'code': 'cancel',
          'name': '취소'
        }
      ]
    }
  },
  methods: {
    code(status) {
      const code = this.statuses.find(st => st.code === status)
      return code ? code.name : status
    }

  }
}
</script>
